/**
 * TB-App API – Generated by orval 🍺
 * Do not edit manually.
 */

export type ClinicalReportMaterialDtoClinicalTestMaterial =
  (typeof ClinicalReportMaterialDtoClinicalTestMaterial)[keyof typeof ClinicalReportMaterialDtoClinicalTestMaterial];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClinicalReportMaterialDtoClinicalTestMaterial = {
  SPUTUM: 'SPUTUM',
  BRONCHIAL_SECRETION: 'BRONCHIAL_SECRETION',
  OTHER: 'OTHER',
} as const;
